export const WORKOUT_TYPES = {
    COACHED_CLASS: "coachedClass",
    LIVE: "live",
    PRE_SET: "preSet",
    FREESSTYLE: "Freestyle",
    BYO: "byo",
};